import styles from './InboxViewDropdowns.module.css';

export type InboxView = 'my-emails';

export type InboxCategory =
  | 'all'
  | 'new-customers'
  | 'orders'
  | 'quotes'
  | 'inquiries'
  | 'internal';

export type InboxSortBy = 'received_at' | 'subject' | 'from';
export type InboxSortOrder = 'asc' | 'desc';

const CATEGORY_OPTIONS: { value: InboxCategory; label: string }[] = [
  { value: 'all', label: 'All Categories' },
  { value: 'new-customers', label: 'New Customers' },
  { value: 'orders', label: 'Order Requests' },
  { value: 'quotes', label: 'Quote Requests' },
  { value: 'inquiries', label: 'General Inquiries' },
  { value: 'internal', label: 'Internal' },
];

const SORT_BY_OPTIONS: { value: InboxSortBy; label: string }[] = [
  { value: 'received_at', label: 'Date' },
  { value: 'subject', label: 'Subject' },
  { value: 'from', label: 'Sender' },
];

const SORT_ORDER_OPTIONS: { value: InboxSortOrder; label: string }[] = [
  { value: 'desc', label: 'Newest First' },
  { value: 'asc', label: 'Oldest First' },
];

interface InboxViewDropdownsProps {
  category?: InboxCategory;
  onCategoryChange?: (category: InboxCategory) => void;
  sortBy?: InboxSortBy;
  onSortByChange?: (sortBy: InboxSortBy) => void;
  sortOrder?: InboxSortOrder;
  onSortOrderChange?: (sortOrder: InboxSortOrder) => void;
}

const InboxViewDropdowns: React.FC<InboxViewDropdownsProps> = ({
  category,
  onCategoryChange,
  sortBy,
  onSortByChange,
  sortOrder,
  onSortOrderChange,
}) => {
  return (
    <div className={styles.dropdowns}>
      {category !== undefined && onCategoryChange && (
        <div className={styles.dropdownGroup}>
          <label className={styles.label} htmlFor="inbox-category-select">
            Category
          </label>
          <select
            id="inbox-category-select"
            className={styles.select}
            data-action="inbox_category"
            data-record-value="category"
            value={category}
            onChange={(e) => onCategoryChange(e.target.value as InboxCategory)}
          >
            {CATEGORY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {sortBy !== undefined && onSortByChange && (
        <div className={styles.dropdownGroup}>
          <label className={styles.label} htmlFor="inbox-sort-by-select">
            Sort By
          </label>
          <select
            id="inbox-sort-by-select"
            className={styles.select}
            data-action="inbox_sort_by"
            data-record-value="sort_by"
            value={sortBy}
            onChange={(e) => onSortByChange(e.target.value as InboxSortBy)}
          >
            {SORT_BY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {sortOrder !== undefined && onSortOrderChange && (
        <div className={styles.dropdownGroup}>
          <label className={styles.label} htmlFor="inbox-sort-order-select">
            Order
          </label>
          <select
            id="inbox-sort-order-select"
            className={styles.select}
            data-action="inbox_sort_order"
            data-record-value="sort_order"
            value={sortOrder}
            onChange={(e) => onSortOrderChange(e.target.value as InboxSortOrder)}
          >
            {SORT_ORDER_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default InboxViewDropdowns;
